import { addDays, differenceInCalendarDays, endOfMonth, getDaysInMonth, parseISO, startOfMonth, startOfWeek } from "date-fns";
import { ymd } from "@/lib/dates";

export const PERIOD_MODES = [
  { id: "week", label: "1 week" },
  { id: "fortnight", label: "2 weeks" },
  { id: "four_weeks", label: "4 weeks" },
  { id: "month", label: "Calendar month (1st to end)" },
  { id: "custom_month", label: "Monthly from a set day (e.g. 18th to 17th)" },
  { id: "pay", label: "Match my pay period" },
  { id: "custom", label: "Custom dates" },
];
export const WEEKDAYS = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
const WEEKS = { week: 1, fortnight: 2, four_weeks: 4 };
export const MAX_DAYS = 63;

const monthStart = (y, m, day) => new Date(y, m, Math.min(day, getDaysInMonth(new Date(y, m, 1))));

export function periodFor(anchor, v) {
  if (WEEKS[v.mode]) {
    const start = startOfWeek(anchor, { weekStartsOn: v.weekStart });
    return { start, end: addDays(start, 7 * WEEKS[v.mode] - 1) };
  }
  if (v.mode === "month") return { start: startOfMonth(anchor), end: endOfMonth(anchor) };
  if (v.mode === "custom_month") {
    const y = anchor.getFullYear();
    const m = anchor.getMonth();
    let start = monthStart(y, m, v.monthDay);
    if (start > anchor) start = monthStart(y, m - 1, v.monthDay);
    const next = monthStart(start.getFullYear(), start.getMonth() + 1, v.monthDay);
    return { start, end: addDays(next, -1) };
  }
  return { start: parseISO(v.customStart), end: parseISO(v.customEnd) };
}

export const periodDays = (p) => Array.from({ length: differenceInCalendarDays(p.end, p.start) + 1 }, (_, i) => addDays(p.start, i));

export function defaultView() {
  const today = new Date();
  return { mode: "week", layout: "staff_rows", weekStart: 1, monthDay: 1, customStart: ymd(today), customEnd: ymd(addDays(today, 13)) };
}

export function loadView() {
  try {
    const saved = localStorage.getItem("rota_view");
    return saved ? { ...defaultView(), ...JSON.parse(saved) } : null;
  } catch {
    return null;
  }
}

export const saveView = (v) => localStorage.setItem("rota_view", JSON.stringify(v));
export const clearView = () => localStorage.removeItem("rota_view");

export const fromBusinessDefault = (d) => {
  const today = new Date();
  return { ...defaultView(), ...d, customStart: ymd(today), customEnd: ymd(addDays(today, (d.customDays || 14) - 1)) };
};

export const toBusinessDefault = (v) => ({
  mode: v.mode, layout: v.layout, weekStart: v.weekStart, monthDay: v.monthDay,
  customDays: Math.min(MAX_DAYS, differenceInCalendarDays(parseISO(v.customEnd), parseISO(v.customStart)) + 1),
});

export const sameView = (a, b) => {
  if (a.mode !== b.mode || a.layout !== b.layout) return false;
  if (["week", "fortnight", "four_weeks"].includes(a.mode)) return a.weekStart === b.weekStart;
  if (a.mode === "custom_month") return a.monthDay === b.monthDay;
  if (a.mode === "custom") return toBusinessDefault(a).customDays === b.customDays;
  return true;
};
